import BillingV2Adapter from './billing-v2';

export default class InvoiceAdapter extends BillingV2Adapter {
  pathForType() {
    return 'payments';
  }
}
